export const fieldCls =
  "mt-1.5 w-full rounded-xl border border-black/10 bg-white px-4 py-3 font-poppins text-[15px] text-neutral-900 outline-none transition-colors placeholder:text-neutral-400 focus:border-[#4E7D2C] focus:ring-2 focus:ring-[#8CC63F]/20";
export const labelCls = "font-poppins text-sm font-medium text-neutral-700";
export const errCls = "mt-1 font-poppins text-xs text-red-500";
